import firebase from "firebase/app";

import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { DistributionChannel } from "astrid-firestore/src/api/distribution/types/DistributionChannel";
import updateDistributionChannel from "astrid-firestore/src/api/distribution/updateDistributionChannel";

import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";

import metadataTemplateTypes from "../constants/metadataTemplateTypes";

import MetadataEditor from "./MetadataEditor";

export default function SuperAdminDistributionChannelMetaDataTemplates({ channel }) {
	const { t } = useTranslation();

	const form = useSimpleForm({
		schema: DistributionChannel,
		defaultValues: {
			ref: channel.ref,
			enabledTemplates: channel.enabledTemplates,
		},
		onSubmit: (data) => {
			return updateDistributionChannel(firebase, data);
		},
	});

	const { error, formState, onSubmit } = form;

	return (
		<>
			<Header as="h3">{t("metadataTemplates", "Metadata templates")}</Header>

			<Card fluid>
				<Card.Content>
					<Card fluid>
						<Card.Content>
							<Form form={form}>
								<Form.Select
									multiple
									name="enabledTemplates"
									label={t("enabledTemplates", "Enabled templates")}
									options={Object.entries(metadataTemplateTypes).map(([key, value]) => ({
										key,
										value,
										text: value,
									}))}
								/>
							</Form>

							{error && <ErrorMessage error={error} />}
						</Card.Content>

						<Card.Content>
							<PrimaryButton
								disabled={formState.isSubmitting || !formState.isDirty}
								loading={formState.isSubmitting}
								onClick={onSubmit}
							>
								{t("save", "Save")}
							</PrimaryButton>
						</Card.Content>
					</Card>

					{channel.enabledTemplates?.map((templateType) => (
						<MetadataEditor key={templateType} channel={channel} templateType={templateType} />
					))}
				</Card.Content>
			</Card>
		</>
	);
}
